import { Download } from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import {
  Avatar,
  Box,
  Chip,
  CircularProgress,
  Divider,
  Grid2,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BookMarkIco from "../../../../assets/icons/BookMarkIco";
import CalenderIco from "../../../../assets/icons/CalenderIco";
import CandidateFitIco from "../../../../assets/icons/CandidateFitIco";
import ClipBoardCheck from "../../../../assets/icons/ClipBoardCheckIco";
import CopyIco from "../../../../assets/icons/CopyIco";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import DotsVerticalIco from "../../../../assets/icons/DotsVerticalIco";
import EyeIco from "../../../../assets/icons/EyeIco";
import RescoreMenuItemIco from "../../../../assets/icons/RescoreMenuItemIco";
import ScalesIco from "../../../../assets/icons/ScalesIco";
import ShareIco from "../../../../assets/icons/ShareIco";
import SourceCandidateIco from "../../../../assets/icons/SourceCandidateIco";
import StrongFitIco from "../../../../assets/icons/StrongFitIco";
import CommonButton from "../../../../component/Button";
import DropDownSelect from "../../../../component/Select";
import { HandleSkeletion } from "../../../../utils/constants";
import {
  CommonGrid2,
  CustomTooltip,
  DotColor,
  StyledFlexColumnView,
  StyledFlexRowView,
  SubTitleTypo,
  TitleTypo,
} from "../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";
import { CommonTippy, CustomAvatar, CustomizeMenu } from "../../style";

function Profile({
  isReviewCandidateProfile,
  matchedData,
  filteredResumeTab,
  resumeId,
  handleDownloadResume,
  handleClickAddNote,
  isCandidatePerspectiveOpen,
  loading,
  handleSaveToCandidatehub,
  handleViewCandidate,
  handleView,
  menuViewLoader,
  downloadMenuLoader,
  handleShareClick,
  isRequestLoading,
  handleRequestInfo,
  candidateProfileValue,
  handleChangeStatus,
  candidateProfileData,
  handleCopyClick,
  handleCopyMouseLeave,
  copied,
  handleQuestionMarkClick,
  iconVisible,
  chatBotData,
  handleEditCandidate,
  handleRescoreCandidate,
  condition_based = false,
  statusOptions,
  resumeIntelligenceCondition,
  request_info,
  request_info_disabled = false,
  profileMenuDisable,
  handleDeleteCandidate,
  deleteIconvisible,
  handleSourceCandidate,
  handleScheduleInterview,
  scheduleMenuLoader,
}) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElCompare, setAnchorElCompare] = React.useState(null);
  const open = Boolean(anchorEl);
  const openCompare = Boolean(anchorElCompare);

  const query = new URLSearchParams(useLocation().search);
  const jobStatus = query.get("status");
  const dataLoading = loading;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseCompare = () => {
    setAnchorElCompare(null);
  };
  const handleClickCompare = (event) => {
    setAnchorElCompare(event.currentTarget);
  };

  const handleCompareNavigate = (item) => {
    navigate(
      `/jobs/candidate/compare/${resumeId}/${item?.id}?title=${query.get(
        "title"
      )}&value=${query.get("value")}&id=${query.get("id")}&match-id=${resumeId}`
    );
  };

  const menuItems = [
    {
      label: "Share",
      icon: <ShareIco />,
      onClick: () => {
        handleShareClick();
        handleClose();
      },
      disabled:
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
    },
    {
      label: "Compare",
      icon: <CalenderIco />,
      onClick: handleClickCompare,
      ariaControls: open ? "basic-menu" : undefined,
      ariaHasPopup: "true",
      ariaExpanded: open ? "true" : undefined,
      disabled:
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
    },
    {
      label: "Add Note",
      icon: <ClipBoardCheck />,
      disabled:
        !matchedData?.rice_created ||
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
      onClick: () => {
        handleClickAddNote();
        handleClose();
      },
    },
    {
      label: "Download",
      disabled: downloadMenuLoader,
      icon: downloadMenuLoader ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <Download sx={{ fontSize: "16px" }} />
      ),
      onClick: handleDownloadResume,
    },
    {
      label: "Edit Profile",
      icon: <EditTwoToneIcon sx={{ fontSize: "16px" }} />,
      disabled:
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
      onClick: () => {
        handleEditCandidate();
        handleClose();
      },
    },

    {
      label: "Rescore",
      icon: <RescoreMenuItemIco />,
      disabled:
        jobStatus === "Closed" ||
        jobStatus === "Cancelled" ||
        jobStatus === "Filled",
      onClick: () => {
        handleRescoreCandidate();
        handleClose();
      },
    },

    ...(matchedData?.temp_rice_created
      ? [
          {
            label: matchedData?.rice_created
              ? "View Profile"
              : "Save to Candidate Hub",

            icon: menuViewLoader ? (
              <CircularProgress
                size={20}
                thickness={5}
                style={{ color: "#667085" }}
              />
            ) : (
              <EyeIco size={"16px"} />
            ),
            disabled:
              menuViewLoader ||
              jobStatus === "Closed" ||
              jobStatus === "Cancelled" ||
              jobStatus === "Filled",
            onClick: async () => {
              if (matchedData?.rice_created) {
                navigate(
                  `/candidates/candidate-view?view-id=${matchedData.resume_id}`
                );
              } else if (matchedData?.duplication_present) {
                handleClose();
                handleViewCandidate();
              } else {
                await handleView();
                handleClose();
              }
            },
          },
        ]
      : []),

    ...(matchedData?.coversheet_submitted === true
      ? [
          {
            label: "Cover Sheet",
            icon: <ClipBoardCheck />,
            disabled:
              jobStatus === "Closed" ||
              jobStatus === "Cancelled" ||
              jobStatus === "Filled",
            onClick: () =>
              navigate(`/coversheet?id=${resumeId}&view_resume=true`),
          },
          {
            label: (
              <>
                Generate Submission
                <br />
                Document
              </>
            ),
            icon: <DescriptionIcon sx={{ fontSize: "16px" }} />,
            onClick: () => {
              navigate(
                `/jobs/submission?title=${query.get("title")}&value=${query.get(
                  "value"
                )}&match-id=${matchedData.id}&pagination=${query.get(
                  "pagination"
                )}&document=${
                  matchedData.submission_document_created
                }&id=${query.get("id")}`
              );
              handleClose();
            },
          },
        ]
      : []),
  ];

  const reviewCandidateProfileMenuItems = [
    {
      label: "Save to Candidate Hub",
      disabled: profileMenuDisable,
      icon: <BookMarkIco />,
      onClick: () => {
        handleClose();
        handleSaveToCandidatehub();
      },
    },

    // {
    //   label: "Schedule Interview",
    //   disabled: !profileMenuDisable || scheduleMenuLoader || downloadMenuLoader,
    //   icon: <ClipBoardCheck />,
    //   onClick: () => {
    //     handleScheduleInterview();
    //     handleClose();
    //   },
    // },
    {
      label: "Compare",
      disabled: true,
      icon: <ScalesIco />,
      onClick: handleClose,
    },
    {
      label: "Rescore",
      disabled: !profileMenuDisable || scheduleMenuLoader || downloadMenuLoader,
      icon: <RescoreMenuItemIco />,
      onClick: () => {
        handleRescoreCandidate();
        handleClose();
      },
    },
    {
      label: "Edit Profile",
      icon: <EditTwoToneIcon sx={{ fontSize: "16px" }} />,
      disabled: !profileMenuDisable || downloadMenuLoader,
      onClick: () => {
        handleEditCandidate();
        handleClose();
      },
    },
    {
      label: "Download",
      disabled: downloadMenuLoader,
      icon: downloadMenuLoader ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <Download sx={{ fontSize: "16px" }} />
      ),
      onClick: handleDownloadResume,
    },

    ...(deleteIconvisible
      ? [
          {
            label: "Delete",
            icon: <DeleteIco strokeWidth={2} size="15px" />,
            onClick: handleDeleteCandidate,
          },
        ]
      : []),
    {
      label: "Match to Active Jobs",
      disabled: !profileMenuDisable || downloadMenuLoader,
      icon: <SourceCandidateIco />,
      onClick: handleSourceCandidate,
    },
  ];

  const candidateGridData = [
    { title: "Inferred Title", contentKey: matchedData?.inferred_title || "-" },
    {
      title: matchedData?.pay_rate?.label,
      contentKey: matchedData?.pay_rate?.value || "-",
    },
    {
      title: matchedData?.location?.label,
      contentKey: matchedData?.location?.value || "-",
      icon: matchedData?.location?.flag,
    },
    {
      title: "Highest Degree",
      contentKey: matchedData?.resume_info?.highest_degree || "-",
      isLink: true,
    },
  ];

  const candidateReviewGridData = [
    {
      title: "Industries",
      contentKey: matchedData?.resume_info?.industry_info || [],
    },
    {
      title: "Occupational Classification",
      contentKey:
        matchedData?.resume_info?.occupational_classification_info || [],
    },
    {
      title: "Countries",
      contentKey: matchedData?.resume_info?.country_info || [],
    },
    { title: "Website", isLink: "-" },
  ];

  const gridData = [
    {
      title: "Inferred Title",
      contentKey: matchedData?.personal_details?.inferred_title || "-",
    },
    {
      title: "Rate",
      contentKey: matchedData?.rate || "-",
    },
    { title: "Source Direct", contentKey: matchedData?.source_type || "" },
    {
      title: "Highest Degree",
      contentKey: matchedData?.personal_details?.highest_degree || "-",
      isLink: true,
    },
    {
      title: "Location",
      contentKey: matchedData?.personal_details?.location || "-",
      icon: matchedData?.personal_details?.location_flag,
    },
  ];

  const reviewGridData = [
    {
      title: "Industries",
      contentKey: matchedData?.personal_details?.industry_info || [],
    },
    {
      title: "Occupational Classification",
      contentKey:
        matchedData?.personal_details?.occupational_classification_info || [],
    },
    { title: "Source Name", name: matchedData?.source_name || "" },
    { title: "Website", isLink: "-" },
    {
      title: "Countries",
      contentKey: matchedData?.personal_details?.country_info || [],
    },
  ];

  const CustomMenuItem = (item, index) => (
    <MenuItem key={index} value={item.id}>
      {item.name}
    </MenuItem>
  );

  return (
    <>
      <Grid2 container columnSpacing={4} rowSpacing={dataLoading ? 2 : 4}>
        {!condition_based && (
          <Grid2 size={12}>
            <Divider />
          </Grid2>
        )}

        {!isCandidatePerspectiveOpen && (
          <Grid2 size={12} marginTop={condition_based && "1rem"}>
            <StyledSpaceBetweenBox>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Avatar
                  alt={matchedData?.candidate_name || "Avatar"}
                  src={matchedData?.avatar_url}
                  sx={{
                    width: 64,
                    height: 64,
                    backgroundColor: "#F2F4F7",
                    color: "#667085",
                    border: "1px solid #D0D5DD",
                    fontFamily: "Inter",
                    fontWeight: 600,
                    fontSize: "24px",
                  }}
                >
                  {dataLoading ? (
                    <HandleSkeletion height={35} width={30} />
                  ) : (
                    !matchedData?.avatar_url &&
                    matchedData?.candidate_name?.[0]?.toUpperCase()
                  )}
                </Avatar>
                <Box>
                  <StyledFlexRowView>
                    <Typography fontSize={"24px"} fontWeight={600}>
                      {dataLoading ? (
                        <HandleSkeletion height={35} width={300} />
                      ) : (
                        matchedData?.candidate_name
                      )}

                      {resumeIntelligenceCondition ? null : dataLoading ? (
                        <HandleSkeletion height={35} width={80} />
                      ) : (
                        <DropDownSelect
                          marginTop="0px"
                          removeAnimation={true}
                          renderValue={false}
                          data={statusOptions}
                          valueChange={true}
                          fullWidth={false}
                          CustomMenuItem={CustomMenuItem}
                          disabled={
                            matchedData?.status == "Rejected" ||
                            jobStatus === "Closed" ||
                            jobStatus === "Cancelled" ||
                            jobStatus === "Filled" ||
                            // matchedData?.status === "Unavailable" ||
                            // matchedData?.status === "Do Not Hire" ||
                            condition_based
                          }
                          handleRenderValue={(selected) => {
                            const selectedOption = statusOptions.find(
                              (option) => option.id === selected
                            );

                            return (
                              <Box display={"flex"} alignItems={"center"}>
                                <DotColor
                                  color={selectedOption.color}
                                  marginRight="8px"
                                />
                                <Typography>{selectedOption.name}</Typography>
                              </Box>
                            );
                          }}
                          customStyle={{
                            "& .MuiSelect-select": {
                              padding: "4px 32px 4px 10px !important",
                              borderRadius: "6px",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#D0D5DD",
                              boxShadow:
                                "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                            },
                            "& .MuiSelect-icon": {
                              right: "0rem",
                            },
                            margin: "0px 10px",
                          }}
                          value={matchedData?.status || candidateProfileValue}
                          handleChange={(e) => handleChangeStatus(e)}
                        />
                      )}
                    </Typography>
                  </StyledFlexRowView>

                  {dataLoading ? (
                    <HandleSkeletion height={35} width={200} />
                  ) : (
                    <>
                      {matchedData?.email ? (
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Link
                            href={`mailto:${matchedData?.email}`}
                            underline="none"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              color: "#7F56D9",
                              fontSize: "16px",
                              fontFamily: "Inter",
                            }}
                          >
                            {matchedData?.email}
                          </Link>
                          <CustomTooltip
                            arrow
                            placement="top"
                            title={copied ? "Copied!" : "Copy to Clipboard"}
                            fontSize="12px"
                            padding="5px 10px"
                            margin="0px 0px 10px !important"
                          >
                            <IconButton
                              onClick={() =>
                                handleCopyClick(matchedData?.email)
                              }
                              style={{ padding: "0px" }}
                              onMouseLeave={handleCopyMouseLeave}
                            >
                              <CopyIco />
                            </IconButton>
                          </CustomTooltip>
                        </Stack>
                      ) : null}
                    </>
                  )}

                  {dataLoading ? (
                    <HandleSkeletion height={35} width={200} />
                  ) : matchedData?.resume_info?.candidate_fit ? (
                    <CommonGrid2
                      display={"flex"}
                      alignItems={"center"}
                      gap={"5px"}
                    >
                      <CommonGrid2
                        background={
                          matchedData?.resume_info?.candidate_fit?.fit ===
                          "Weak Fit"
                            ? "#ff070026"
                            : matchedData?.resume_info?.candidate_fit?.fit ===
                              "Strong Fit"
                            ? "#ECFDF3"
                            : "#ffa6022e"
                        }
                        borderRadius="5px"
                        width="max-content"
                        padding="4px 10px"
                        display={"flex"}
                        alignItems={"center"}
                        gap={"5px"}
                      >
                        {matchedData?.resume_info?.candidate_fit?.fit ===
                          "Strong Fit" && <StrongFitIco />}
                        <Typography
                          variant="p"
                          fontWeight={700}
                          fontSize={"14px"}
                          color={
                            matchedData?.resume_info?.candidate_fit?.fit ===
                            "Weak Fit"
                              ? "#dd0600"
                              : matchedData?.resume_info?.candidate_fit?.fit ===
                                "Strong Fit"
                              ? "#067647"
                              : "#ffa500"
                          }
                        >
                          {matchedData?.resume_info?.candidate_fit?.fit}
                        </Typography>
                      </CommonGrid2>

                      <IconButton
                        onClick={() =>
                          handleQuestionMarkClick(
                            chatBotData.geminiBubble &&
                              chatBotData.geminiBubble.length !== 0
                              ? chatBotData.geminiBubble.filter(
                                  (item) => item.question === "Candidate fit"
                                )[0]
                              : chatBotData.bubble.filter(
                                  (item) => item.question === "Candidate fit"
                                )[0]
                          )
                        }
                        style={{ opacity: !iconVisible ? 0.5 : 1 }}
                        disabled={!iconVisible}
                      >
                        <CandidateFitIco />
                      </IconButton>
                    </CommonGrid2>
                  ) : null}
                </Box>
              </Stack>

              {dataLoading ? (
                <HandleSkeletion height={100} width={200} />
              ) : (
                <>
                  {!condition_based && (
                    <CommonGrid2
                      gap={"1rem"}
                      flexWrap="wrap"
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={"end"}
                    >
                      {/* {isReviewCandidateProfile ? null : (
                        <CommonButton
                          value={"Schedule Interview"}
                          padding={"10px 14px"}
                          variant="outlined"
                          size="small"
                          color="rgb(127, 86, 217)"
                          borderRadius="8px"
                          fontWeight={600}
                          border="rgb(127, 86, 217)"
                          onClick={handleChangeScheduleInterview}
                          disabled={
                            !matchedData?.rice_created ||
                            matchedData.status == "Rejected" ||
                            jobStatus === "Closed" ||
                            jobStatus === "Cancelled" ||
                            jobStatus === "Filled"
                          }
                        />
                      )} */}
                      <CommonButton
                        value={request_info || "Request Info"}
                        padding={"10px 14px"}
                        variant="outlined"
                        color={"#344054"}
                        border={"#D0D5DD"}
                        fontWeight={"600"}
                        onClick={handleRequestInfo}
                        loading={isRequestLoading}
                        disabled={
                          loading ||
                          request_info_disabled ||
                          isRequestLoading ||
                          matchedData?.rice_created === false ||
                          matchedData?.submission_document_updated ||
                          matchedData?.status == "Rejected" ||
                          jobStatus === "Closed" ||
                          jobStatus === "Cancelled" ||
                          jobStatus === "Filled"
                        }
                      />

                      <div>
                        <CommonButton
                          value={<DotsVerticalIco />}
                          padding={"10px 14px"}
                          variant="outlined"
                          color={"#344054"}
                          border={"#D0D5DD"}
                          fontWeight={"600"}
                          svg={true}
                          aria-controls={open ? "basic-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          onClick={handleClick}
                          minWidth={"20px !important"}
                          disabled={isRequestLoading}
                        />

                        <CustomizeMenu
                          id="basic-menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          {(isReviewCandidateProfile
                            ? reviewCandidateProfileMenuItems
                            : menuItems
                          ).map((item, index) => (
                            <MenuItem
                              key={index}
                              onClick={item.disabled ? () => {} : item.onClick}
                              aria-controls={item.ariaControls}
                              aria-haspopup={item.ariaHasPopup}
                              aria-expanded={item.ariaExpanded}
                              style={{ opacity: item.disabled ? 0.5 : 1 }}
                              disabled={item?.disabled}
                            >
                              <StyledFlexRowView>
                                {item.icon}
                                <Typography>{item.label}</Typography>
                              </StyledFlexRowView>
                            </MenuItem>
                          ))}
                        </CustomizeMenu>

                        <Menu
                          id="basic-menu"
                          anchorEl={anchorElCompare}
                          open={openCompare}
                          onClose={handleCloseCompare}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                        >
                          {filteredResumeTab?.map((item, imdex) => (
                            <MenuItem
                              sx={{ marginTop: "10px" }}
                              onClick={() => handleCompareNavigate(item)}
                            >
                              <>
                                <ListItemIcon>
                                  <Avatar
                                    alt={"a"}
                                    src="https://mui.com/static/images/avatar/1.jpg"
                                    sx={{ width: 24, height: 24 }}
                                  />
                                </ListItemIcon>
                                <ListItemText>
                                  <Typography>{item?.name}</Typography>
                                </ListItemText>
                                <Chip
                                  label={`${item?.score}%`}
                                  variant="outlined"
                                  size="small"
                                  sx={{
                                    paddingX: "5px",
                                    paddingY: "1px",
                                    marginLeft: "30px",
                                  }}
                                />
                              </>
                            </MenuItem>
                          ))}
                        </Menu>
                      </div>
                    </CommonGrid2>
                  )}
                </>
              )}
            </StyledSpaceBetweenBox>
          </Grid2>
        )}
      </Grid2>
      <CommonGrid2
        display={"flex"}
        gap={"1rem"}
        justifyContent={"space-between"}
        margin={"2rem 0px 0.5rem"}
      >
        {(candidateProfileData ? candidateGridData : gridData).map((item) => (
          <Grid2
            size={3}
            key={item.id}
            // backgroundColor="#F2F4F7"
            // borderRadius={"10px"}
            padding={"10px"}
            width={"100%"}
          >
            {dataLoading ? (
              <HandleSkeletion height={50} />
            ) : (
              <StyledFlexColumnView gap={"6px"}>
                <CommonTippy
                  content={item.title}
                  placement="top"
                  color={"#7F56D9"}
                  fontSize="12px"
                >
                  <TitleTypo
                    fontWeight={600}
                    color="#5B738B"
                    whiteSpace="nowrap"
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    {item.title}
                  </TitleTypo>
                </CommonTippy>
                <CommonGrid2 display={"flex"} gap={"8px"}>
                  {item?.icon && (
                    <CustomAvatar
                      src={item.icon}
                      width={"22px"}
                      height="21px"
                      borderRadius="50%"
                      margin="0px 0px 4px 0px"
                    />
                  )}
                  <SubTitleTypo fontSize={"15px"}>
                    {item.contentKey}
                  </SubTitleTypo>
                </CommonGrid2>
              </StyledFlexColumnView>
            )}
          </Grid2>
        ))}
      </CommonGrid2>
      <CommonGrid2
        display={"flex"}
        justifyContent={"space-between"}
        margin={"0rem 0px 2rem"}
        gap={"1rem"}
      >
        {(candidateProfileData ? candidateReviewGridData : reviewGridData).map(
          (item) => (
            <CommonGrid2
              size={3}
              key={item.id}
              // backgroundColor="#F2F4F7"
              // borderRadius={"10px"}
              padding={"10px"}
              width={"100%"}
              // scrollStyle={true}
              // height={"130px"}
              // overflowY={item.contentKey?.length >= 3 ? "scroll" : "none"}
              // scrollBar="5px"
            >
              {dataLoading ? (
                <HandleSkeletion height={50} />
              ) : (
                <StyledFlexColumnView gap={"5px"}>
                  <CommonTippy
                    content={item.title}
                    placement="top"
                    color={"#7F56D9"}
                    fontSize="12px"
                  >
                    <TitleTypo
                      fontWeight={600}
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                      color="#5B738B"
                    >
                      {item.title}
                    </TitleTypo>
                  </CommonTippy>
                  {item?.contentKey &&
                    item?.contentKey?.length !== 0 &&
                    item?.contentKey?.map((year) => (
                      <CommonGrid2
                        display={"flex"}
                        justifyContent={"space-between"}
                        gap={"4px"}
                      >
                        <CommonTippy
                          content={
                            year.industry ||
                            year.occupational_classification ||
                            year.country
                          }
                          placement="top"
                          color={"#7F56D9"}
                          fontSize="11px"
                        >
                          <CommonGrid2
                            display={"flex"}
                            justifyContent={"space-between"}
                            gap={"6px"}
                          >
                            {year?.flag && (
                              <CustomAvatar
                                src={year.flag}
                                width={"22px"}
                                height="21px"
                                borderRadius="50%"
                                margin="0px 0px 4px 0px"
                              />
                            )}
                            <SubTitleTypo
                              fontSize="15px"
                              whiteSpace="nowrap"
                              overflow="hidden"
                              textOverflow="ellipsis"
                            >
                              {year.industry ||
                                year.occupational_classification ||
                                year.country}
                            </SubTitleTypo>
                          </CommonGrid2>
                        </CommonTippy>
                        <SubTitleTypo
                          fontSize="15px"
                          color="#8396A8"
                          whiteSpace="pre"
                        >
                          {year.duration_in_years} yrs
                        </SubTitleTypo>
                      </CommonGrid2>
                    ))}
                  {item.isLink && (
                    <SubTitleTypo fontSize={"15px"}>{item.isLink}</SubTitleTypo>
                  )}
                  {item.name && (
                    <SubTitleTypo fontSize={"14px"}>{item.name}</SubTitleTypo>
                  )}
                </StyledFlexColumnView>
              )}
            </CommonGrid2>
          )
        )}
      </CommonGrid2>
      {!isCandidatePerspectiveOpen && (
        <Grid2 size={12}>
          <Divider />
        </Grid2>
      )}
    </>
  );
}

export default Profile;
